import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DialogService } from 'src/app/services/dialog.service';
import { VideoconsultaBackendService } from 'src/app/services/videoconsulta-backend.service';
import { PopupBody } from 'src/app/types/PopupBody';
import { UploadConsentBody } from 'src/app/types/UploadConsentBody';

@Component({
  selector: 'app-rec-permit',
  templateUrl: './consent-recording.component.html',
  styleUrls: ['../popup/popup.component.css'],
})
export class ConsentRecordingComponent implements OnInit {
  title: string;
  body: string;
  btns: string[];
  isMedic: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: PopupBody,
    private _videoconsulta: VideoconsultaBackendService,
    private _dialog: DialogService
  ) {}

  ngOnInit() {
    const { title, body, btns, isMedic } = this.data;
    this.title = title;
    this.body = body;
    this.btns = btns;
    this.isMedic = isMedic;
  }

  closePopup(value: boolean): void {
    const { cid } = this.data;

    this._videoconsulta.sendConsentRecording(cid, value).subscribe({
      next: () => {
        let body: UploadConsentBody = { cid };

        this.isMedic === 1
          ? (body.consentimientoMedico = value)
          : (body.consentimientoSocio = value);

        this._videoconsulta
          .uploadConsentSelection(body)
          .toPromise()
          .catch((err) => console.log(err));
      },
      error: (err) => console.log(err),
      complete: () => this._dialog.closeDialog(),
    });
  }
}
